import { createContext, useContext } from "react";

export type NotificationType = "success" | "error" | "info" | "warning";

export interface Notification {
  message: string;
  type: NotificationType;
  duration?: number;
  closable?: boolean;
  showIcon?: boolean;
  styles?: React.CSSProperties;
}

export interface NotificationContext {
  notify: (notification: Notification) => void;
}

const createNotificationContext = <A extends object | null>() => {
  const ctx = createContext<A | undefined>(undefined);
  const useNotificationCtx = () => {
    const c = useContext(ctx);
    if (c === undefined) {
      throw new Error(
        "useNotificationCtx must be inside a Provider with a value"
      );
    }
    return c;
  };
  return [useNotificationCtx, ctx] as const;
};

export const [useNotificationContext, NotificationContext] =
  createNotificationContext<NotificationContext>();
